import TableCell, { TableCellProps } from '@mui/material/TableCell';
import classNames from 'classnames';
import type { FC } from 'react';

import styles from './styles.module.scss';

export const TableHeadCell: FC<TableCellProps> = ({ className, ...props }) => (
  <TableCell className={classNames(className, styles.headingCell)} {...props} />
);
